module.exports = __webpack_public_path__ + "assets/img/ic-filter-hover.c7fa2651.svg";